import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { SelectPickerField } from 'components/form/selectpicker'

const FacebookReaction = ({ name }) => (
  <div>
    <Field
      name={`${name}.value`}
      component={SelectPickerField}
      defaultValue='like'
      multiple
    >
      <option value='like'>LIKE</option>
      <option value='love'>LOVE</option>
      <option value='care'>CARE</option>
      <option value='haha'>HAHA</option>
      <option value='wow'>WOW</option>
      <option value='sad'>SAD</option>
      <option value='angry'>ANGRY</option>
    </Field>
    <Field name={`${name}.primary`} component='input' type='hidden' value />
  </div>
)

FacebookReaction.propTypes = {
  name: PropTypes.string
}

export default FacebookReaction



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/facebook/reaction/index.js